import { PurchaseOrdersService } from "../../../api/purchaseOrders"
import { useCreateWarehouseDocumentDraft } from "../shared/useCreateWarehouseDocumentDraft"

export function useCreateZZ() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft({
      mutationKey: ["wms", "purchase-orders"] as const,
      documentCode: "ZZ",
      blockedWarehouseDescription:
        "Magazyn z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu ZZ.",
      createDraftRequest: (payload: { warehouse_id: string }) =>
        PurchaseOrdersService.initPurchaseOrderDraft(payload),
      buildPayload: (warehouseId: string) => ({
        warehouse_id: warehouseId,
      }),
      getSuccessNavigation: (draft) => ({
        to: "/WMS/documents/purchase-orders/$purchaseOrder",
        params: { purchaseOrder: draft.id },
        search: { edit: 1 } as any,
      }),
    })

  return {
    createZZ: (preferredWarehouseId?: string) =>
      createDocument({ preferredWarehouseId }),
    isCreating,
    isResolvingWarehouses,
    canCreate,
  }
}
